import { addDays } from 'date-fns'
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'
import getCashRegisterCloseLast from '../../axios/order/cashRegisterCloseLast'
import getOrdersUnpaid from '../../axios/orderview/ordersUnpaid'
import { setUnpaidModal } from '../../action/unpaidOrdersModal'
import { setAppErrors } from '../../action/system'
import { retrieveErrorFromApi } from '../../../helper'

const BERLIN_TZ = 'Europe/Berlin'

// Operational days without a cash-register close before the blocking modal kicks in.
export const BLOCKING_THRESHOLD_DAYS = 4

export const getDayStart = (zTimeIso) => {
	const berlinWallClock = utcToZonedTime(new Date(zTimeIso), BERLIN_TZ)
	const isBeforeCutoff = berlinWallClock.getHours() < 7
	const dayOffset = isBeforeCutoff ? -1 : 0

	const berlinDayStart = new Date(
		berlinWallClock.getFullYear(),
		berlinWallClock.getMonth(),
		berlinWallClock.getDate() + dayOffset,
		7, 0, 0, 0,
	)

	return zonedTimeToUtc(berlinDayStart, BERLIN_TZ)
}

export const isBlockingThreshold = (zTimeIso, now = new Date()) => {
	const dayStart = getDayStart(zTimeIso)
	const threshold = addDays(dayStart, BLOCKING_THRESHOLD_DAYS)
	return now >= threshold
}

const EPOCH_ISO = new Date(0).toISOString()

export const getOldestOrderDate = (orders) =>
	orders.reduce((oldest, order) => (new Date(order.orderDate) < new Date(oldest) ? order.orderDate : oldest), orders[0].orderDate)

export const checkUnpaidOnLoginThunk = () => async (dispatch) => {
	try {
		const lastRes = await getCashRegisterCloseLast()
		const last = lastRes.data || null

		const now = new Date()
		const todayStart = getDayStart(now.toISOString())

		if (last != null && getDayStart(last.zTime).getTime() === todayStart.getTime()) {
			return
		}

		// Only unpaid orders from previous operational days count; without a prior close scan from the
		// epoch so a shop that never closes is still caught by its oldest still-unpaid order.
		const dateTo = todayStart.toISOString()
		const ordersRes = await getOrdersUnpaid(last?.zTime ?? EPOCH_ISO, dateTo)
		const orders = ordersRes.data

		if (!orders || orders.length === 0) {
			return
		}

		// Days overdue count from the last close, or — if there never was one — from the oldest unpaid order.
		const dateFrom = last?.zTime ?? getOldestOrderDate(orders)
		const blocking = isBlockingThreshold(dateFrom, now)

		dispatch(setUnpaidModal({ dateFrom, dateTo, blocking }))
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}
